import { rankingBoards } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

type RankItem = { name: string; value: string; trend: string };

const trendIcon: Record<string, { icon: string; color: string }> = {
  up: { icon: "ri-arrow-up-line", color: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", color: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", color: "text-foreground-400" },
};

function RankList({ items, accent }: { items: RankItem[]; accent: "primary" | "accent" }) {
  return (
    <ol className="divide-y divide-background-200/70">
      {items.map((item, index) => {
        const trend = trendIcon[item.trend] ?? trendIcon.flat;
        const isTop = index < 3;
        return (
          <li key={item.name}>
            <a
              href="#collections"
              className="group flex items-center gap-3 py-3 transition-colors cursor-pointer"
            >
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-label text-xs font-semibold ${
                  isTop
                    ? accent === "primary"
                      ? "bg-primary-500 text-background-50"
                      : "bg-accent-500 text-foreground-950"
                    : "bg-background-200 text-foreground-700"
                }`}
              >
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="min-w-0 flex-1 truncate text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                {item.name}
              </span>
              <span className="hidden shrink-0 font-label text-xs text-foreground-500 sm:block">
                {item.value}
              </span>
              <span className={`flex h-4 w-4 shrink-0 items-center justify-center ${trend.color}`}>
                <i className={trend.icon} />
              </span>
            </a>
          </li>
        );
      })}
    </ol>
  );
}

export default function RankingBoard() {
  return (
    <section id="ranking" className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="热度榜单"
        title="这周被翻得最多的专题与标签"
        desc="榜单只按站内浏览与收藏统计，收录进仓库的内容越完整，被反复查阅的次数通常也越多。"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div className="rounded-xl border border-background-200/80 bg-background-50 p-4 md:p-5">
          <div className="mb-3 flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-stack-line text-sm" />
              </span>
              专题热榜
            </h3>
            <span className="font-label text-[11px] tracking-wide text-foreground-400">
              WEEK 37
            </span>
          </div>
          <RankList items={rankingBoards.topics} accent="primary" />
        </div>

        <div className="rounded-xl border border-background-200/80 bg-background-50 p-4 md:p-5">
          <div className="mb-3 flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-price-tag-3-line text-sm" />
              </span>
              标签热榜
            </h3>
            <span className="font-label text-[11px] tracking-wide text-foreground-400">
              WEEK 37
            </span>
          </div>
          <RankList items={rankingBoards.tags} accent="accent" />
        </div>
      </div>
    </section>
  );
}